import { isUndefined } from 'lodash-es';
import { propOr } from 'ramda';
import { useBonusesStore } from '../../store';

const selectActiveBsDepositBonusId = () => propOr([], 'bsDepositBonuses');
export const useActiveBsDepositBonusId = () => {
  const bsDepositBonuses = useBonusesStore(selectActiveBsDepositBonusId());

  return (
    bsDepositBonuses?.find(
      ({ isSelectedDeposit, bonusId }) =>
        isSelectedDeposit && !isUndefined(bonusId)
    )?.bonusId || null
  );
};
